import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/layout/app-layout/app-layout';
import InboxTab from './InboxTab';
import styles from './page-inbox.module.scss';

const PageInbox: FC = () => {
  const [t] = useTranslation('dashboard');
  return (
    <AppLayout title={t('inbox.title', 'Inkorg')}>
      <div className={styles.container}>
        <InboxTab />
      </div>
    </AppLayout>
  );
};

export default PageInbox;
